import React, { FC } from 'react';
import { SchemaForm } from '@gba/questionnaire-antd';
import type { QuestionnaireSchema } from '@gba/questionnaire-antd';
import { useQuestionnaireResponse } from '@/api/Questionnaire';
import { FormSkeleton } from '@/ui/components';
import { answersToValues } from './answersToValues';
import { ReadOnlyImageAnswer } from './ReadOnlyImageAnswer';

interface QuestionnaireReadOnlyProps {
  responseId: number;
}

export const QuestionnaireReadOnly: FC<QuestionnaireReadOnlyProps> = ({
  responseId,
}) => {
  const { data, isFetching } = useQuestionnaireResponse(responseId);

  if (isFetching || !data) {
    return <FormSkeleton />;
  }

  return (
    <SchemaForm
      template={JSON.parse(data.templateSnapshot) as QuestionnaireSchema}
      initialValues={answersToValues(data.answers)}
      readOnly
      renderControl={({ field, value }) =>
        field.ui.control === 'image' ? (
          <ReadOnlyImageAnswer
            paths={Array.isArray(value) ? (value as string[]) : []}
            answerImages={data.answerImages}
          />
        ) : undefined
      }
    />
  );
};
